import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CustomerDropMultipleService } from '../../services/repos/customer-drop-multiple/customer-drop-multiple.service';

/**
 * Blocks /customer/drop-multiple unless the customerDropMultiple brand feature
 * is explicitly enabled.
 *
 * Uses CustomerDropMultipleService.isEnabled() rather than
 * BrandService.isFeatureEnabled, because the latter defaults a MISSING flag to
 * true. See the comment on isEnabled().
 */
export const customerDropMultipleGuard: CanActivateFn = () => {
  const customerDropMultipleService = inject(CustomerDropMultipleService);
  const router = inject(Router);

  if (customerDropMultipleService.isEnabled()) {
    return true;
  }

  console.warn(
    'Route access denied: customer/drop-multiple (feature customerDropMultiple disabled)'
  );
  router.navigate(['/menu']);
  return false;
};
